<template>
    <v-col cols="12">
        <v-select
            label="Approximately how wide will the majority of your prints be?"
            v-model="form.copier.printing_dims"
            variant="outlined"
            density="compact"
            :items="choices">
        </v-select>
    </v-col>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form } = storeToRefs(store)

const choices = [
  '17-24"',
  '24-36"',
  '36-48"',
  '48-60" or more',
  'Not sure',
]
</script>
